import { render } from "./hired_employees.vue?vue&type=template&id=621bc4d2&scoped=true"
import script from "./hired_employees.vue?vue&type=script&lang=js"
export * from "./hired_employees.vue?vue&type=script&lang=js"

import "./hired_employees.vue?vue&type=style&index=0&id=621bc4d2&scoped=true&lang=css"

import exportComponent from "../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621bc4d2"]])

export default __exports__